import moment from 'moment';
import { array } from 'prop-types';
import React, { Component } from 'react'
import { Header, Segment, Button, Grid, Divider, Modal, Icon,Popup, Message} from 'semantic-ui-react'
import AddPropertyVisitInput from './add_property_visit_input'
import { getPVClerks,getPVClerkLeaves } from '../../data/user_api';
import BulkEdit from './bulk_edit';
import { createPVs, updatePVs } from '../../data/property_visit_api';
import AssignClerk from '../inspection/assign_clerk';

export class AddPropertyVisit extends Component {

  constructor(props) {
    super(props);
    this.state = {
      addVisitDate: undefined,
      addVisitAddress: "",
      addVisitCompany: "",
      addVisitClerk: 0,
      addVisitTime: "",
      addVisitTenantName: "",
      addVisitTenantContact: "",
      addVisitTenantEmail: "",
      addVisitNotes:"",
      addAccessNotes:"",
      addVisitStatus: 0,
      addVisitTTConfirmed:false,
      addVisitBranch:"",
      addedVisits: [],
      clerkOptions: [],
      companyOptions:[],
      initialized: true,
      showDetails: true,
      isSaving: false,
      infoMessage: undefined, 
      showAddInput:true,
      clerkSet:undefined,
      dateSet:undefined,
      clerkNameDict: undefined,
      clerkLeaveMap:[],
      viewSchedDate:undefined

    };
  }

  initializeCheckedVisits() {
    let statusOptions =
    {
      'pending': 0,
      'scheduled': 1,
      'confirmed': 2,
      'processing': 3,
      'submitted': 4,
      'completed': 5,
      'cancelled': 6,
      'aborted' :7,
      'contacted':8
    }
    let checkedVisitsArr = [];
    for (let i = 0; i < this.props.checkedVisits.length; i++){
    let checkedVisit = {
      visitDate: this.props.checkedVisits[i].visit_date,
      visitAddress: this.props.checkedVisits[i].address,
      visitCompany: this.props.checkedVisits[i].company,
      visitClerk: this.props.checkedVisits[i].user_id,
      visitTime: this.props.checkedVisits[i].visit_time,
      visitStatus: statusOptions[this.props.checkedVisits[i].status],
      visitTenantName: this.props.checkedVisits[i].tenant_name,
      visitTenantContact: this.props.checkedVisits[i].tenant_contact,
      visitTenantEmail: this.props.checkedVisits[i].tenant_email,
      visitNotes: this.props.checkedVisits[i].notes,
      visitAccessNotes:this.props.checkedVisits[i].access_notes,
      visitConclusionNotes: this.props.checkedVisits[i].conclusion_notes,
      visitId: this.props.checkedVisits[i].id,
      visitTTConfirmed:this.props.checkedVisits[i].tenant_confirmed,
      visitBranch:this.props.checkedVisits[i].branch
    };
    checkedVisitsArr.push({ ...checkedVisit });
  }
    

    this.setState({ addedVisits: checkedVisitsArr });
  }

  componentDidMount() {

    if (this.props.editMode || this.props.duplicate) {
      this.initializeCheckedVisits()
    }
    getPVClerks().then((response) => {
      let clerkOptions = [{ value: 0, text: "UNASSIGNED", key: 0 }];
      let companyOptions = [];
      let clerkNameDict = {}
      response.clerk_profiles.map((clerk) => {
        let clerkObj = {
          value: clerk.user_id,
          text: clerk.name,
          key: clerk.user_id,
        };
        clerkOptions.push(clerkObj);
        clerkNameDict[clerk.user_id] = clerk.name
      });

      response.companies.map((company, index) => {
        let companyObj = {
          title: company.name,
          key: index,
        };
        companyOptions.push(companyObj);
      });
      this.setState({ clerkOptions: clerkOptions,companyOptions:companyOptions,clerkNameDict:clerkNameDict });
      this.updateDateAndClerkListAndCheckLeave()
    });
  }

  updateDateAndClerkListAndCheckLeave = () =>{
    let clerkDateLog = new Map();

    this.state.addedVisits.map(visit =>{
      if (visit.visitClerk && !clerkDateLog.has(visit.visitClerk)) {
        clerkDateLog.set(visit.visitClerk, new Set());
      }
      if(visit.visitDate && clerkDateLog.has(visit.visitClerk)) {
        let date = new Date(visit.visitDate).toISOString().split('T')[0]; 
        clerkDateLog.get(visit.visitClerk).add(date);
      }
    } )
    const jsonReady = Object.fromEntries(
      Array.from(clerkDateLog, ([clerk, dates]) => [clerk, Array.from(dates)])
    );

    getPVClerkLeaves(jsonReady).then(response => {
      let clerkLeaveMap = new Map();
    
      response.forEach(clerk => {
        if (clerk.leaves.length > 0) {
          clerkLeaveMap.set(clerk.name, new Set());
    
          clerk.leaves.forEach(leave => {
            // Use local timezone-safe formatting
            const date = new Date(leave.start_time).toLocaleDateString("en-CA"); // "YYYY-MM-DD"
            clerkLeaveMap.get(clerk.name).add(date);
          });
        }
      });
    
      // Convert Map to array of [clerkName, Set] for rendering
      const clerkLeaveArray = Array.from(clerkLeaveMap.entries());
    
      this.setState({ clerkLeaveMap: clerkLeaveArray });
    });
    
  }

  bulkEdit = (type, payload) => {
    let newAddedVisits = [...this.state.addedVisits];
    switch (type) {
      case "company":
        for (let x = 0; x < newAddedVisits.length; x++) {
          newAddedVisits[x].visitCompany = payload
        }
        break;
        case "date":
          for (let x = 0; x < newAddedVisits.length; x++) {
            newAddedVisits[x].visitDate = payload
          }
        break;
        case "time":
          for (let x = 0; x < newAddedVisits.length; x++) {
            newAddedVisits[x].visitTime = payload
          }
        break;
      case "clerk":
          for (let x = 0; x < newAddedVisits.length; x++) {
            newAddedVisits[x].visitClerk = payload
          }
        break;
        case "status":
          for (let x = 0; x < newAddedVisits.length; x++) {
            if (newAddedVisits[x].visitStatus != 6){
              newAddedVisits[x].visitStatus = payload
            }
          }
        break;
        case "branch":
          for (let x = 0; x < newAddedVisits.length; x++) {
            newAddedVisits[x].visitBranch = payload
          }
          break;
          case "notes":
          for (let x = 0; x < newAddedVisits.length; x++) {
            newAddedVisits[x].visitNotes = payload
          }
          break;
           case "access":
          for (let x = 0; x < newAddedVisits.length; x++) {
            newAddedVisits[x].visitAccessNotes = payload
          }
          break;
    }
    this.setState({ addedVisits: newAddedVisits, initialized: false },()=>{this.setState({ initialized: true })})
    

  }

  handleSave = async () => {
    this.setState({isSaving:true})
    let pvData = { pvData: this.state.addedVisits }
    let response 
    if (this.props.editMode) {
      response = await updatePVs(pvData)
     } else {
      response = await createPVs(pvData)
    }
    if (response.success) {
      this.setState({ addedVisits: [], infoMessage: { type: "green", message: "Successfully Created PVs" } })
            setTimeout(() => {
                this.setState({infoMessage: undefined})
            }, 3000);
      if (this.props.editMode) {
        this.props.refreshData()
      }
    } else {
      this.setState({ addedVisits: [], infoMessage: { type: "red", message: "Error in Saving PVs" } })
      setTimeout(() => {
          this.setState({infoMessage: undefined})
      }, 3000);
    }
    this.setState({isSaving:false})
  }

  parseCSVLine = (line) => {
    const fields = [];
    let insideQuotes = false;
    let field = "";
    for (let i = 0; i < line.length; i++) {
        const char = line.charAt(i);
        if (char === '"') {
            insideQuotes = !insideQuotes;
        } else if (char === "," && !insideQuotes) {
            fields.push(field.trim().replace(/^['"]+|['"]+$/g, ''));
            field = "";
        } else {
            field += char;
        }
    }
    fields.push(field); // Add the last field
    return fields;
}
  handleImport = async () => {
    let fileText = await this.state.csvFile.text()
    var pvArray = fileText.split("\r\n")
    let newVisitArray = []
    for (let i = 1; i < pvArray.length; i++) {
      if (pvArray[i].length != 0) {
        let pvData = this.parseCSVLine(pvArray[i])
        let newVisit = {
          visitDate: undefined,
          visitAddress: pvData[0],
          visitCompany: pvData[1],
          visitClerk: 0,
          visitTime: pvData[2],
          visitStatus: 0,
          visitTenantName: pvData[3],
          visitTenantEmail: pvData[4],
          visitTenantContact: pvData[5],
          visitNotes:pvData[6],
          visitBranch:pvData[7],
          visitTTConfirmed:false
        };
        if (newVisit.visitAddress != "" && newVisit.visitCompany != "") {
          newVisitArray.push(newVisit)
        }
      }
    }
    this.setState({addedVisits:newVisitArray,initialized:false},() =>{this.setState({initialized:true})})

  }
  addOrDeleteVisit = (arrayIndex = undefined) => {
    let newAddedVisits = [...this.state.addedVisits];
    if (arrayIndex != undefined) {
      newAddedVisits.splice(arrayIndex, 1);
      this.setState({ addedVisits: newAddedVisits });
    } else {
      if (
        this.state.addVisitAddress != "" &&
        this.state.addVisitCompany != ""
      ) {
        newAddedVisits.push({
          visitDate: this.state.addVisitDate,
          visitAddress: this.state.addVisitAddress,
          visitCompany: this.state.addVisitCompany,
          visitClerk: this.state.addVisitClerk,
          visitTime: this.state.addVisitTime,
          visitStatus: this.state.addVisitStatus,
          visitTenantName: this.state.addVisitTenantName,
          visitTenantEmail: this.state.addVisitTenantEmail,
          visitTenantContact: this.state.addVisitTenantContact,
          visitNotes:this.state.addVisitNotes,
          visitAccessNotes:this.state.addAccessNotes,
          visitConclusionNotes:this.state.addVisitConclusionNotes,
          visitTTConfirmed:this.state.addVisitTTConfirmed,
          visitBranch:this.state.addVisitBranch
        });
        this.setState({
          showAddInput:false,
          addedVisits: newAddedVisits,
          addVisitDate: undefined,
          addVisitAddress: "",
          addVisitCompany: "",
          addVisitClerk: 0,
          addVisitTime: "",
          addVisitStatus: 0,
          addVisitTenantName:"",
          addVisitTenantEmail:"",
          addVisitTenantContact:"",
          addVisitNotes:"",
          addAccessNotes:"",
          addVisitConclusionNotes:"",
          addVisitTTConfirmed:false,
          addVisitBranch:""   
        }, ()=>{this.setState({showAddInput:true})});
      }
    }
  };
  handleDataChange = (arrayIndex, value, type) => {
    if (arrayIndex != undefined) {
      let newAddedVisits = [...this.state.addedVisits];
      switch (type) {
        case "address":
          newAddedVisits[arrayIndex].visitAddress = value;
          break;
        case "date":
          newAddedVisits[arrayIndex].visitDate = value;
          break;
        case "company":
          newAddedVisits[arrayIndex].visitCompany = value;
          break;
        case "clerk":
          newAddedVisits[arrayIndex].visitClerk = value;
          break;
        case "time":
          newAddedVisits[arrayIndex].visitTime = value;
          break;
        case "status":
          newAddedVisits[arrayIndex].visitStatus = value;
          break;
          case "ttName":
            newAddedVisits[arrayIndex].visitTenantName = value;
          break;
          case "ttContact":
            newAddedVisits[arrayIndex].visitTenantContact = value;
          break;
          case "ttEmail":
            newAddedVisits[arrayIndex].visitTenantEmail = value;
          break;
          case "ttConfirm":
            newAddedVisits[arrayIndex].visitTTConfirmed = !newAddedVisits[arrayIndex].visitTTConfirmed;
          break;
          case "notes":
            newAddedVisits[arrayIndex].visitNotes = value;
          break;
           case "access":
            newAddedVisits[arrayIndex].visitAccessNotes = value;
          break;
          case "conclusionNotes":
            newAddedVisits[arrayIndex].visitConclusionNotes = value;
          break;
          case "branch":
            newAddedVisits[arrayIndex].visitBranch = value;
          break;  
      }
      this.setState({ addedVisits: newAddedVisits });
      if(type == "clerk" || type == "date") {
        this.updateDateAndClerkListAndCheckLeave()
      }
    } else {
      switch (type) {
        case "address":
          this.setState({ addVisitAddress: value });
          break;
        case "date":
          this.setState({ addVisitDate: value });
          break;
        case "company":
          this.setState({ addVisitCompany: value });
          break;
        case "clerk":
          this.setState({ addVisitClerk: value });
          break;
        case "time":
          this.setState({ addVisitTime: value });
          break;
        case "status":
          this.setState({ addVisitStatus: value });
          break;
        case "ttName":
          this.setState({ addVisitTenantName: value });
          break;
        case "ttContact":
          this.setState({ addVisitTenantContact: value });
          break;
        case "ttEmail":
          this.setState({ addVisitTenantEmail: value });
          break;
          case "ttConfirm":
            this.setState({ addVisitTTConfirmed: !this.state.addVisitTTConfirmed });
          break;
        case "notes":
          this.setState({ addVisitNotes: value });
          break;
          case "access":
          this.setState({ addAccessNotes: value });
          break;
          case "conclusionNotes":
            this.setState({ addVisitConclusionNotes: value });
          break;   
          case "branch":
            this.setState({ addVisitBranch: value });
          break;    
      }
    }
  };
  downloadExamplefile = () => {
    let csvString = "Property Address,Company,Time,Tenant Name,Tenant Email,Tenant Contact,Notes,Branch"
    let hiddenElement = document.createElement('a');  
    hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(csvString);  
    hiddenElement.target = '_blank';  
    hiddenElement.download = 'PV Import.csv';  
    hiddenElement.click();  
  }
  render() {
    return (
      <div className="pv-create-propertylist-table">
        <div className="pad-top" style={{ paddingBottom: 0 }}>
          <Header
            content={`${this.props.editMode? "Edit":"Add"} Property Visits`}
            size="large"
            textAlign="left"
          />
          <Segment>
            <Segment secondary>
                <Header>Bulk Edit</Header>
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Company"} companyOptions={this.state.companyOptions} type={"company"} />
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Date"} type={"date"}/>
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Time"} type={"time"}/>
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Clerk"} type={"clerk"}  clerkOptions={this.state.clerkOptions} />
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Status"} type={"status"} />
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Branch"}  type={"branch"} />
              <BulkEdit bulkEditFunction={this.bulkEdit} headerTitle={"Notes"}  type={"notes"} />
              
              <Button icon primary loading={this.state.isSaving } disabled={this.state.isSaving || this.state.addedVisits.length < 1} onClick={() =>{this.handleSave()} } style={{ float: "right" }}> <Icon name="save"></Icon>{this.props.editMode? "Save" : "Create"}</Button>
              {!this.props.editMode && <Popup on="click" position="bottom left" flowing wide="very" size="large" trigger={<Button icon style={{ float: "right" }}> <Icon name="download"></Icon>Import from CSV</Button>}>
                <div style={{textAlign:"center"}}>
                <input type={"file"} accept={".csv"} onChange={(e) => { this.setState({ csvFile: e.target.files[0] }) }}></input><hr/>{this.state.csvFile && <Button onClick={() => this.handleImport()}>Import</Button>}<Button onClick={()=>{this.downloadExamplefile()}}>Example File</Button></div></Popup>}
              <Button icon basic onClick={() =>{this.props.editMode} } color='blue' style={{ float: "right" }}>PV Number: {this.state.addedVisits.length }</Button>
              <Button icon compact  style={{ float: "right" }} onClick={() => { this.setState({ showDetails: !this.state.showDetails }); }}><Icon name={!this.state.showDetails ? "eye" :"hide"}></Icon>{!this.state.showDetails ? "Show" :"Hide"} TT Details/Notes</Button>
            </Segment>
            {this.state.clerkLeaveMap.map(clerk =>{
              return <Message negative key={clerk[1]}>
                    <Message.Header>Clerk Leaves Detected</Message.Header>
                    <ul>
              {Array.from(clerk[1].entries()).map(msg =>{return <li>There is a leave scheduled for {clerk[0]} on {moment(msg[0]).format("DD-MM-YYYY")}<Button onClick={()=>{this.setState({viewSchedDate:msg[0]})}}>View in Schedule</Button></li>})}
              </ul></Message>
            })}
            {this.state.infoMessage && <div ><Message header={this.state.infoMessage.message} color={this.state.infoMessage.type} onDismiss={() => { this.setState({infoMessage: undefined}) }}/></div>}
{            this.state.viewSchedDate && <Segment>
                                    <div style={{position:'absolute',right:'10px'}}>
                                        <Button basic icon negative onClick={(e) => {
                                            this.setState({viewSchedDate:undefined})
                                        }}><Icon name="close"/></Button>
                                    </div>
                                    <Modal.Description>
                                        {this.state.viewSchedDate && <div style={{minHeight:'500px'}}><AssignClerk date={this.state.viewSchedDate} viewOnly={true} /></div> }
                                    </Modal.Description>
                                    </Segment>}
            <Header>Property Visits To Be {this.props.editMode ? "Edited":"Created"} <Button compact onClick={()=>{this.setState({viewSchedDate:moment().format("YYYY-MM-DD")})}}> Show Inventory Schedule</Button></Header>
            {this.state.addedVisits.length == 0 && <span>No Visits ready to be saved, use the form below to add some to this list</span>}
            <Segment.Group>
            {!this.state.showDetails &&<Segment style={{ marginBottom: "0px" }} secondary>
                <Grid
                  divided
                  style={{ marginTop: "0px" }}
                  columns={6}
                  stackable
                >
                   <Grid.Row style={{ paddingTop: "0px", marginBottom: "0px" }}>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={5}
                    >
                      <span>Property Address</span>
                    </Grid.Column>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={2}
                    >
                      <span>Company</span>
                    </Grid.Column>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={2}
                    >
                      <span>Date</span>
                    </Grid.Column>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={2}
                    >
                      <span>Time</span>
                    </Grid.Column>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={2}
                    >
                      <span>Clerk</span>
                    </Grid.Column>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={2}
                    >
                      <span>Status</span>
                    </Grid.Column>
                    <Grid.Column
                      className="align-center-pv-table-header"
                      width={1}
                    >
                      <span>Action</span>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>}
              {this.state.addedVisits.map((visit, index) => {
                return (
                  <AddPropertyVisitInput editMode={this.props.editMode} showDetails={this.state.showDetails} initialized={this.state.initialized}
                    zebraRow={index % 2 != 0? true:false}
                    companyOptions={this.state.companyOptions}
                    clerkOptions={this.state.clerkOptions}
                    key={index}
                    createMode={false}
                    arrayIndex={index}
                    addOrDeleteVisit={this.addOrDeleteVisit}
                    visitAddress={visit.visitAddress}
                    handleDataChange={this.handleDataChange}
                    visitTime={visit.visitTime}
                    visitCompany={visit.visitCompany}
                    visitClerk={visit.visitClerk}
                    visitDate={visit.visitDate}
                    visitStatus={visit.visitStatus}
                    visitTenantName={visit.visitTenantName}
                    visitTenantContact={visit.visitTenantContact}
                    visitTenantEmail={visit.visitTenantEmail}
                    visitNotes={visit.visitNotes}
                    visitAccessNotes={visit.visitAccessNotes}
                    visitTTConfirmed={visit.visitTTConfirmed}
                    visitConclusionNotes = {visit.visitConclusionNotes}
                    visitBranch = {visit.visitBranch}
                  />
                );
              })}
            </Segment.Group>
          </Segment>
          {!this.props.editMode && <React.Fragment>
          <Divider></Divider>
          <Segment tertiary>
            <Header>Add To Create List</Header>
              {this.state.showAddInput && <AddPropertyVisitInput
                zebraRow={true}
                showDetails={this.state.showDetails}
                initialized={true}
                clerkOptions={this.state.clerkOptions}
                companyOptions={this.state.companyOptions}
                addOrDeleteVisit={this.addOrDeleteVisit}
                createMode={true}
                visitAddress={this.state.addVisitAddress}
                handleDataChange={this.handleDataChange}
                visitTime={this.state.addVisitTime}
                visitCompany={this.state.addVisitCompany}
                visitClerk={this.state.addVisitClerk}
                visitDate={this.state.addVisitDate}
                visitStatus={this.state.addVisitStatus}
                visitTenantName={this.state.addVisitTenantName}
                visitTenantContact={this.state.addVisitTenantContact}
                visitTenantEmail={this.state.addVisitTenantEmail}
                visitNotes={this.state.addVisitNotes}
                visitAccessNotes={this.state.addAccessNotes}
                visitConclusionNotes={this.state.addVisitConclusionNotes}
                visitTTConfirmed={this.state.addVisitTTConfirmed}
                visitBranch={this.state.addVisitBranch}
              />}
            </Segment>

            </React.Fragment>}
        </div>
      </div>
    );
  }
}

export default AddPropertyVisit


// WEBPACK FOOTER //
// ./src/views/property_visits/add_property_visit.js